var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as uuid from 'uuid';
var uuidv4 = uuid.v4;
var SoundDownloadManager = /** @class */ (function () {
    function SoundDownloadManager() {
        this.cache = [];
        this._soundIdStateListeners = {};
    }
    SoundDownloadManager.getInstance = function () {
        if (SoundDownloadManager.instance) {
            return SoundDownloadManager.instance;
        }
        SoundDownloadManager.instance = new SoundDownloadManager();
        return SoundDownloadManager.getInstance();
    };
    SoundDownloadManager.prototype.toggleSound = function (sound) {
        if (this.cache.map(function (m) { return m.id; }).includes(sound.id)) {
            this.removeSound(sound);
        }
        else {
            this.addSound(sound);
        }
    };
    SoundDownloadManager.prototype.addSounds = function (sounds) {
        this.cache = this.cache.concat(sounds).unique('id');
        this.callSoundStateListeners();
    };
    SoundDownloadManager.prototype.addSound = function (sound) {
        this.cache.push(sound);
        this.callSoundStateListeners();
    };
    SoundDownloadManager.prototype.clear = function () {
        this.cache = [];
        this.callSoundStateListeners();
    };
    SoundDownloadManager.prototype.removeSound = function (sound) {
        this.cache = this.cache.filter(function (s) { return s.id != sound.id; });
        this.callSoundStateListeners();
    };
    SoundDownloadManager.prototype.removeSounds = function (sounds) {
        var ids = sounds.map(function (s) { return s.id; });
        this.cache = this.cache.filter(function (s) { return !ids.includes(s.id); });
        this.callSoundStateListeners();
    };
    SoundDownloadManager.prototype.addSoundStateListener = function (listener) {
        var _a;
        var id = uuidv4();
        this._soundIdStateListeners = __assign(__assign({}, this._soundIdStateListeners), (_a = {}, _a[id] = listener, _a));
        return id;
    };
    SoundDownloadManager.prototype.removeSoundStateListener = function (id) {
        delete this._soundIdStateListeners[id];
    };
    SoundDownloadManager.prototype.getSounds = function () {
        return this.cache;
    };
    SoundDownloadManager.prototype.callSoundStateListeners = function () {
        var _this = this;
        Object.keys(this._soundIdStateListeners || {}).map(function (key) { return (_this._soundIdStateListeners || {})[key]; }).forEach(function (data) {
            var cb = data;
            cb(_this.cache.slice());
        });
    };
    return SoundDownloadManager;
}());
export default SoundDownloadManager;
//# sourceMappingURL=SoundDownloadManager.js.map